import { createAction } from 'redux-starter-kit';

export const putChecklistCategory = createAction('PUT_CHECKLIST_CATEGORY');
export const putChecklistCategories = createAction('PUT_CHECKLIST_CATEGORIES');
export const putChecklistCategoryReferences = createAction('PUT_CHECKLIST_CATEGORY_REFERENCES');
